import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import DialogContent from "@material-ui/core/DialogContent";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import { copyPartLocal, getMahdoodeFaniCopy } from "Stores/actions";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import * as Icons from 'react-bootstrap-icons';
import { DialogActions, Radio } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { mahdoodeFaniCopy } from "Constants/TableColumns";
import { ReactSVG } from "react-svg";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";
import { useTranslation } from "react-i18next";
import checkBoxCheckIcon from "Assets/svg/icon/checkBoxCheckIcon.svg";
import checkedBoxIcon from "Assets/svg/icon/checkedBoxIcon.svg";
import showNotify from "Helpers/Notify";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function CopyProduct({ prow, products, onCopy }) {
    const { direction } = useTheme();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [selectedRow, setSelectedRow] = useState({});
    const [tblData, setTblData] = useState([]);
    const [tblPagination, setTblPagination] = useState({ Limit: 5, Page: 1, Total: 0 });
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const { selectedBazsho } = useSelector((state) => ({ selectedBazsho: state.yaragh.selectedBazsho }));

    const handleDialog = () => {
        setOpenDialog(!openDialog);
    }

    const onEnter = async() => {
        setSearch("");
        setSelectedRow({});
        await getData(1);
    }

    const setValue = async (name, value) => {
        setSearch(value);
    }

    const getData = async (_page, search = null) => {
        setLoading(true);
        const params = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            IdPop: +selectedBazsho.Id,
            Limit: 5,
            Page: _page ? _page : tblPagination.Page ? tblPagination.Page : 1,
            ...search
        };
        const result = await dispatch(getMahdoodeFaniCopy(params));
        if(result) {
            setTblData(result.list.map((item, index) => {
                return { num: (((result.pagination.Page - 1) * 5) + index + 1), ...item }
            }));
            setTblPagination(result.pagination);
        }
        setLoading(false);
    }

    const onSearch = async (e) => {
        e.preventDefault();
        await getData(1, { name: search });
    }

    const onClearSearch = async (e) => {
        e.preventDefault();
        setSearch("");
        await getData(1);
    }

    const onTableChange = async (type, { page, sizePerPage }) => {
        setLoading(true);
        if (type === "pagination") {
          try {
            setSelectedRow({});
            await getData(page);
            setTblPagination({
              ...tblPagination,
              Page: page
            })
          } catch (err) {
      console.error('[catch error]', err)
    }
        }
        setLoading(false);
    }

    const selectRow = {
        mode: "radio",
        clickToSelect: true,
        onSelect: (row) => setSelectedRow(row),
        selected: [selectedRow?.Id],
        classes: "selection-row",
        selectionRenderer: ({ checked, disabled }) => {
            return (
                <Radio
                    className="selectRadio"
                    checked={checked}
                    disabled={disabled}
                    color="default"
                    // size="small"
                    // checkedIcon={<ReactSVG src={checkBoxCheckIcon} />}
                    // icon={<ReactSVG src={checkedBoxIcon} />}
                />
            );
        },
    };

    const onFinish = async (e) => {
        e.preventDefault();
        if(prow.Id !== selectedRow.Id) {
            try {
                setLoading(true);
                const data = {
                    KeyGroup: read("groupKey"),
                    KeyUser: read("userKey"),
                    idRangeTechnicalFitting: prow.Id,
                    newIdRangeTechnicalFitting: selectedRow.Id,
                    ids: products,
                };
                await dispatch(copyPartLocal(data));
                onCopy();
                handleDialog();
                setLoading(false);
            } catch (e) {
                console.log('new part local', e);
                setLoading(false);
            }
        } else {
            showNotify({
                text: t('same_source_and_destination'),
                customClass: "error",
            });
        }
    }

    return (
        <>
            <MuiButton
                onClick={handleDialog}
                color="primary"
                title={
                    <span className="text-nowrap d-flex g-2 align-items-center">
                        <Icons.ClipboardCheck size={14}/>
                        <Translator id="copy_product" />
                    </span>
                }
            />
            <Dialog
                dir={direction}
                open={openDialog}
                onClose={handleDialog}
                TransitionProps={{
                    onEnter: onEnter,
                }}
                fullWidth
                maxWidth="xs"
            >
                <div>
                    <BackDropLoading loading={loading} />
                    <div className="dialogHeader">
                        <p>{t('copy_product')}</p>
                    </div>
                    <DialogContent id="content-dialog-manager-inner">
                        <Grid container spacing={2}>
                            <Grid item xs={12} className="mb-2">
                                <Input
                                    setValue={setValue.bind(this)}
                                    name="search"
                                    value={search}
                                    placeholder={t('nameSearch')}
                                    type="search"
                                    onSearch={onSearch}
                                    onClearSearch={onClearSearch}
                                />
                            </Grid>
                            <RemoteTable
                                data={tblData}
                                selectRow={selectRow}
                                keyField="num"
                                columns={mahdoodeFaniCopy}
                                loading={loading}
                                page={tblPagination.Page}
                                sizePerPage={5}
                                sizePerPageList={[{ text: "5",value: 5 }]}
                                totalSize={tblPagination.Total}
                                onTableChange={onTableChange}
                                title={<Translator id="list_Fani" />}
                                className={'no-width-limit'}
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <MuiButton
                            onClick={onFinish}
                            color="primary"
                            title={`${t('copy_product_to')} ${selectedRow.Code ? selectedRow.Code : '...'}`}
                            className="w-100"
                            disabled={!selectedRow.Code}
                        />
                        <MuiButton
                            onClick={handleDialog}
                            title={<Translator id="enseraf" />}
                        />
                    </DialogActions>
                </div>
            </Dialog>
        </>
    );
}

export default CopyProduct;
